import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AlertService } from '../alert.service';
import { PermissionsService } from '../permissions.service';

export const permissionsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const permission = route.data['permission'];

  const hasPermission =
    inject(PermissionsService).checkHavePermissions(permission);

  if (!hasPermission) {
    inject(AlertService).danger(
      `Você não tem permissão para acessar a página ${route.data['page']}!`
    );

    if (route.data['returnUrl'])
      inject(Router).navigate([route.data['returnUrl']]);
  }

  return hasPermission;
};
